import './Footer.scss';

function Footer() {
  return (
    <div className="Footer">
      {/* <h1>Footer</h1> */}
      <div className="Footer_reseaux">
        <i className="fa-brands fa-tiktok"></i>
        <i className="fa-brands fa-snapchat"></i>
        <i className="fa-brands fa-instagram"></i>
        <i className="fa-brands fa-facebook-f"></i>
        <i className="fa-brands fa-youtube"></i>
      </div>
      {/* <div className="Footer_infos">
        <a href="#">Qui sommmes-nous</a>
        <a href="#">Mentions légales</a>
        <a href="#">Conditions générales</a>
        <a href="#">Gestion des cookies</a>
        <a href="#">Données personnelles</a>
        <a href="#">Témoignages</a>
        <a href="#">Avis</a>
      </div> */}
    </div>
  );
}

export default Footer;